import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-html',
  template: `
    <div
      class='widget-border'
      data-testid="widget-html"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-html-v0
        *ngSwitchCase='0'
        [lockAcquired]='false'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-html-v0>


      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetHtmlComponent extends WidgetInputDirective {
}
